import genererEcheancierContrat from '@/services/baux/contrat/genererEcheancierContrat';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { generationEcheancier } from '@/api/baux/contrat';
import genererGuid from '@/services/general/genererGuid';
import formatDate from '@/services/general/formatIsoDate';

export default async function genererEcheancierBail(bail, ligne) {
  const echeancier = genererEcheancierContrat();
  echeancier.dateDebut = bail.dateDebutEcheance;
  echeancier.dateFin = bail.dateFinEcheance;
  echeancier.finPremiereEcheance = bail.dateFinPremiereEcheance;
  echeancier.termePaiement = bail.termePaiement;
  echeancier.quantitePeriodicite = bail.quantitePeriodicite;
  echeancier.periodiciteEcheancier = bail.unitePeriodicite;
  echeancier.montantAnnuelHt = bail.loyerAnnuelHt;
  echeancier.pourcentageTva = bail.tauxTva;
  echeancier.modeReglementId = ligne.modeReglement ? store
    .getters['parametres/parametre'](PARAMETRES_KEYS.modeReglement).find((modeReglement) => {
      return modeReglement.libelle.toLowerCase().trim()
        === ligne.modeReglement.toLowerCase().trim();
    }).id : null;
  bail.intervenants.forEach((intervenant) => {
    echeancier.tiersRepartitions.push({
      tiersId: intervenant.tiersId,
      aRapprocher: intervenant.surFacture,
      repartition: intervenant.repartition,
      modeReglementId: intervenant.modeReglementId,
    });
  });
  const ligneEcheance = (await generationEcheancier(echeancier)).data.result;
  ligneEcheance.forEach((ligne) => {
    ligne.finPeriode = formatDate(new Date(ligne.finPeriode));
    ligne.debutPeriode = formatDate(new Date(ligne.debutPeriode));
    ligne.dateEcheance = formatDate(new Date(ligne.dateEcheance));
    ligne.key = genererGuid();
    ligne.selected = false;
    ligne.listeProduits = [];
    ligne.pourcentageTva = echeancier.pourcentageTva;
    ligne.montantFactureTtc = 0;
    ligne.montantPaye = 0;
    ligne.tiers = {
      nomCommercial: bail.intervenants.find((intervenant) => {
        return intervenant.tiersId === ligne.tiersId;
      }).tiers.nomCommercial,
    };
  });
  return ligneEcheance;
}
